import { useEffect, useRef, type RefObject } from 'react';

/** Scroll so `anchor`'s top sits at the top of `viewport` (content may extend below). */
export function scrollChatAnchorToTop(
  viewport: HTMLElement | null,
  anchor: HTMLElement | null,
): void {
  if (!viewport || !anchor) return;
  const top =
    anchor.getBoundingClientRect().top
    - viewport.getBoundingClientRect().top
    + viewport.scrollTop;
  viewport.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
}

/**
 * Keeps the top of the latest chat turn in view so long replies build downward
 * off-screen instead of snapping the viewport to the bottom.
 */
export function useScrollLatestChatToTop(
  messageCount: number,
  latestMessageKey: string | number | undefined,
): {
  viewportRef: RefObject<HTMLDivElement>;
  latestMessageRef: RefObject<HTMLDivElement>;
} {
  const viewportRef = useRef<HTMLDivElement>(null);
  const latestMessageRef = useRef<HTMLDivElement>(null);
  const previousKeyRef = useRef<string | undefined>(undefined);

  useEffect(() => {
    const nextKey = `${messageCount}:${latestMessageKey ?? ''}`;
    if (previousKeyRef.current === nextKey) return;
    previousKeyRef.current = nextKey;
    scrollChatAnchorToTop(viewportRef.current, latestMessageRef.current);
  }, [messageCount, latestMessageKey]);

  return { viewportRef, latestMessageRef };
}
